import { MultiTierTax } from './../../classes/multiTierTax/multiTierTax';
import { rates } from './config';
import { VennootschapsBelastingConfig } from './interface';

export class VennootschapsBelasting {
    
    tax: number;
    
    constructor(data: VennootschapsBelastingConfig) {
        this.tax = new MultiTierTax(rates[data.year], data.profit).tax;
    }
    
}
